import { User } from '../types';

/**
 * Creates dropdown options when selecting a user to impersonate in Boss mode
 */
export const formatUserOptions = (users: User[]) =>
  users
    .sort((itemA, itemB) => itemA.orgId - itemB.orgId)
    .map(({ orgName, orgId, email }) => ({
      id: orgId.toString(),
      label: email,
      value: email,
      doubleLine: `Org Id: ${orgId} | ${orgName}`,
      searchtext: `${orgId} ${orgName} ${email}`.toLowerCase(),
    }));
